import { Link, Tooltip } from "@mui/material";

export default function ContactName({ name, phone }: { name: string; phone?: string | null }) {
  const number = phone?.trim();
  if (!name || !number) return <>{name}</>;

  return (
    <Tooltip title={number}>
      <Link
        href={`tel:${number}`}
        color="inherit"
        underline="hover"
        onClick={(event) => event.stopPropagation()}
        sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      >
        {name}
      </Link>
    </Tooltip>
  );
}
